import script from "./AutoComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoComplete.vue?vue&type=script&setup=true&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=0c578b9c&lang=css"

const __exports__ = script;

export default __exports__